import React, { useEffect, useState } from "react";
import useFetchData from "../API/useFetchData";
import useFetchMedia from "../API/useGetMedia";
import Masonry from "react-masonry-css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import LoadingComponent from "../Components/LoadingComponent/LoadingComponent";
import { usePhotos } from "../Redux/PhotosContext.js";
import { useNavigate } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import RemoveDoneIcon from "@mui/icons-material/RemoveDone";
import SidebarAccepted from "../Components/Sidebar/SideBarAccepted.jsx";
import {
  Button,
  SelectAll,
  // Logout, TODO:: use later
} from "../Components/Sidebar/SidebarAcceptedStyles.js";
const Accepted = () => {
  const { fetchData } = useFetchData("/manager/photos");
  const { fetchMedia } = useFetchMedia();
  const { acceptedPhotos: photos, setAcceptedPhotos: setPhotos } = usePhotos();
  const [loading, setLoading] = useState(false);
  const [click, setClick] = useState(false);
  const navigate = useNavigate();
  const [selectAll, setSelectAll] = useState(false);
  const [selectedPhotos, setSelectedPhotos] = useState([]);
  const toggleSelectPhoto = (photo) => {
    if (selectedPhotos.includes(photo.id)) {
      setSelectedPhotos(selectedPhotos.filter((id) => id !== photo.id));
    } else {
      setSelectedPhotos([...selectedPhotos, photo.id]);
    }
  };
  useEffect(() => {
    if (photos.length > 0) return;
    const loadPhotos = async () => {
      setLoading(true);
      try {
        const response = await fetchData({ approved: "true" });
        for (const photo of response) {
          const photoAccepted =
            photo.editedPhotoUrl && photo.editedPhotoUrl.trim() !== ""
              ? photo.editedPhotoUrl
              : photo.photoUrl;
          const media = await fetchMedia(photoAccepted);
          setPhotos((prevPhotos) => [
            ...prevPhotos,
            {
              id: photo.id,
              url: media, // Placeholder for the actual media URL
              uploadedBy: photo.uploadedBy,
              approved: photo.approved,
              createdAt: photo.createdAt,
              updatedAt: photo.updatedAt,
              className: photo.className,
              yearName: photo.yearName,
              lovedCount: photo.lovedCount,
              shareCount: photo.shareCount,
            },
          ]);
        }
      } catch (error) {
        console.error("Error fetching photos:", error);
      }
      setLoading(false);
    };

    loadPhotos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleImageClick = (id, startindex) => {
    // store index in local storage
    localStorage.setItem("index", startindex);
    navigate("/AcceptedImageView");
  };

  const handleClick = () => setClick(!click);
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedPhotos([]);
    } else {
      setSelectedPhotos(photos.map((photo) => photo.id));
    }
    setSelectAll(!selectAll);
  };

  const breakpointColumnsObj = {
    default: 4,
    1100: 4,
    700: 2,
    500: 1,
  };
  return (
    <div className="App">
      {photos.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh", // Center vertically in full view height
            fontSize: "24px", // Adjust font size as needed
            color: "rgba(255, 255, 255, 1)", // Adjust text color as needed
          }}
        >
          There are no accepted images yet
        </div>
      ) : (
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {photos.map((photo) => (
            <div
              key={photo.id}
              style={{
                position: "relative",
                marginBottom: "10px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {click && (
                <Checkbox
                  checked={selectedPhotos.includes(photo.id)}
                  onChange={() => toggleSelectPhoto(photo)}
                  sx={{
                    position: "absolute",
                    top: "30px",
                    left: "5px",
                    zIndex: 1,
                    transform: "scale(2.0)", // Scale the checkbox to make it bigger
                    cursor: "pointer",
                    color: "rgba(0, 0, 0, 0.7)", // Checkbox color when unchecked
                    "&.Mui-checked": {
                      color: "rgba(0, 0, 0, 0.7)", // Checkbox color when checked
                    },
                  }}
                />
              )}
              <div
                className="image-container"
                onClick={() => {
                  if (click) {
                    toggleSelectPhoto(photo);
                  } else {
                    handleImageClick(photo.id, photos.indexOf(photo));
                  }
                }}
              >
                <img
                  alt={photo.uploadedBy}
                  src={photo.url.url}
                  style={{
                    width: "100%",
                    display: "block",
                    borderRadius: "10px",
                    transition: "filter 0.3s ease",
                  }}
                />
                <div
                  className="love-count"
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    right: "10px",
                    display: "flex",
                    alignItems: "center",
                    color: "white",
                    fontSize: "20px", // Larger font size for prominence
                    backgroundColor: "rgba(211, 47, 60, 0.7)", // Semi-transparent background
                    padding: "1px 5px",
                    borderRadius: "5px",
                    marginBottom: "15px",
                  }}
                >
                  <i
                    className="fa-solid fa-heart"
                    style={{ marginRight: "5px" }}
                  ></i>
                  {photo.lovedCount}
                </div>
                <div
                  className="love-count"
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    right: "70px",
                    display: "flex",
                    alignItems: "center",
                    color: "white",
                    fontSize: "20px",
                    backgroundColor: "rgba(35, 143, 221, 0.5)",
                    padding: "1px 5px",
                    borderRadius: "5px",
                    marginBottom: "15px",
                  }}
                >
                  <i
                    className="fa-solid fa-share"
                    style={{ marginRight: "5px", marginLeft: "10px" }}
                  ></i>
                  {photo.shareCount || 0}
                </div>
              </div>
            </div>
          ))}
          {loading && (
            <div
              key={0}
              style={{
                position: "relative",
                marginBottom: "10px",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              <LoadingComponent size="40%" thickness={1} color="neutral" />
            </div>
          )}
        </Masonry>
      )}
      {photos.length !== 0 && (
        <Button clicked={click} onClick={() => handleClick()}>
          {click ? "Done" : ""}
        </Button>
      )}
      {click && (
        <SelectAll onClick={() => handleSelectAll()}>
          {!selectAll ? (
            <>
              Select All <DoneAllIcon style={{ marginLeft: "0.5rem" }} />
            </>
          ) : (
            <>
              Clear All <RemoveDoneIcon style={{ marginLeft: "0.5rem" }} />
            </>
          )}
        </SelectAll>
      )}
      {click && (
        <SidebarAccepted
          photos={photos}
          selectedPhotos={selectedPhotos}
        />
      )}
    </div>
  );
};

export default Accepted;
